module.exports = __webpack_public_path__ + "img/espaço-10.e200d94c.jpeg";